<template>
  <div class="container">
    <br />
    <Input v-model="title" placeholder="字段标题" style="width: 100px" />
    <span class="line">&nbsp;-&nbsp;</span>
    <Input v-model="message" placeholder="字段内容" style="width: 300px" />
    <div class="jian" @click="jian()">
      <img class="jian_img" src="@/assets/images/jian.png" alt="" srcset="" />
    </div>
    <br />
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      message: "",
    };
  },
  props: ["titles", "messages"],
  watch: {
    titles(add, old) {
      this.title = add;
    },
    messages(add, old) {
      this.message = add;
    },
    title(add, old) {
      this.$emit("titleTxt", add);
    },
    message(add, old) {
      this.$emit("message", add);
    },
  },
  methods: {
    jian() {
      this.$emit("delect", "");
    },
  },
};
</script>

<style scoped >
.container {
  width: 100%;
  display: flex;
  flex-direction: row;
  padding: 10px;
}

.line {
  line-height: 32px;
}

.jian {
  margin-left: 10px;
  height: 32px;
  width: 32px;
  cursor: pointer;
}

.jian_img {
  width: 100%;
}
</style>
